import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import FlightSearch from './pages/FlightSearch.vue';
import BookingLookup from './pages/BookingLookup.vue';
import RequestHistory from './pages/RequestHistory.vue';
import Preferences from './pages/Preferences.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.TRAVEL,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/travel/bookings'),
    component: BookingLookup,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'travel_booking_lookup',
        component: BookingLookup,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/travel/history'),
    component: RequestHistory,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'travel_request_history',
        component: RequestHistory,
        meta: commonMeta,
      },
    ],
  },
  {
    // Account-wide search behaviour, so administrators only.
    path: frontendURL('accounts/:accountId/travel/preferences'),
    component: Preferences,
    meta: { ...commonMeta, permissions: ['administrator'] },
    children: [
      {
        path: '',
        name: 'travel_preferences',
        component: Preferences,
        meta: { ...commonMeta, permissions: ['administrator'] },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/travel/flights'),
    component: FlightSearch,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'travel_flight_search',
        component: FlightSearch,
        meta: commonMeta,
      },
    ],
  },
];
